import React, { useCallback, useContext, useEffect, useState } from "react";

import { ClipPolygon } from "fond/svg_icons";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarToggleButton from "./ToolbarToggleButton";
import { useGeometryTypeCheck } from "./useGeometryTypeCheck";

const CutButton: React.FC<IButtonProps> = ({ icon, mode, title = "Cut features", ...rest }) => {
  const { drawControl, map } = useContext(MapContext);
  const [isDisabled, setIsDisabled] = useState(true);
  const isPolygonLayer = useGeometryTypeCheck("Polygon");

  /**
   * Monitor when the selectionchange event occurs so that we can disabled
   * this feature based on if a single Multipolygon is selected.
   */
  const handleOnSelect = useCallback(() => {
    const selectedFeatures = drawControl.current?.getSelected().features || [];

    // Confirm that the selected feature is a multiPolygon but also have multiple coordinates.
    if (selectedFeatures.length > 0) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [drawControl]);

  useEffect(() => {
    map?.on("draw.selectionchange", handleOnSelect);

    return () => {
      map?.off("draw.selectionchange", handleOnSelect);
    };
  }, [map, handleOnSelect]);

  const handleOnChange = () => {
    if (mode === "cut_polygon_passing_draw_polygon") {
      drawControl.current?.changeMode("simple_select");
      map?.fire("draw.modechange", { type: "draw.modechange", mode: "simple_select" });
    } else {
      drawControl.current?.changeMode("cut_polygon");
    }
  };

  const selected = mode === "cut_polygon_passing_draw_polygon";
  return (
    <ToolbarToggleButton
      title={title}
      {...rest}
      value="cut"
      selected={mode === "cut_polygon_passing_draw_polygon"}
      onChange={handleOnChange}
      disabled={!isPolygonLayer || (!selected && isDisabled)}
    >
      {icon || <ClipPolygon />}
    </ToolbarToggleButton>
  );
};

export default CutButton;
